import { render, staticRenderFns } from "./sendinquiry.vue?vue&type=template&id=09b816cc&scoped=true&"
import script from "./sendinquiry.vue?vue&type=script&lang=js&"
export * from "./sendinquiry.vue?vue&type=script&lang=js&"
import style0 from "./sendinquiry.vue?vue&type=style&index=0&id=09b816cc&lang=scss&scoped=true&"
import style1 from "./sendinquiry.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b816cc",
  null
  
)

export default component.exports